(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["search-results-list.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros.njk", false, "search-results-list.njk", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(Object.prototype.hasOwnProperty.call(t_1, "search_result")) {
var t_4 = t_1.search_result;
} else {
cb(new Error("cannot import 'search_result'")); return;
}
context.setVariable("search_result", t_4);
output += "\n\n<h2 class=\"sumo-card-heading search-results-heading mb-0\">\n  ";
if(runtime.contextOrFrameLookup(context, frame, "num_results") > 0) {
output += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "total_is_approximate")) {
output += "\n      ";
output += "\n      ";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("f").call(context, (lineno = 6, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ngettext"), "ngettext", context, ["Showing the most relevant result for ‘<span>%(q)s</span>’ in ‘<span>%(product)s</span>’ from about %(n)s potential match","Showing the most relevant results for ‘<span>%(q)s</span>’ in ‘<span>%(product)s</span>’ from about %(n)s potential matches",runtime.contextOrFrameLookup(context, frame, "num_results")])),{"n": runtime.contextOrFrameLookup(context, frame, "num_results"),"q": runtime.contextOrFrameLookup(context, frame, "q"),"product": runtime.contextOrFrameLookup(context, frame, "product_titles")},true)), env.opts.autoescape);
output += "\n    ";
;
}
else {
output += "\n      ";
output += "\n      ";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("f").call(context, (lineno = 13, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ngettext"), "ngettext", context, ["Found %(n)s result for ‘<span>%(q)s</span>’ for ‘<span>%(product)s</span>’","Found %(n)s results for ‘<span>%(q)s</span>’ for ‘<span>%(product)s</span>’",runtime.contextOrFrameLookup(context, frame, "num_results")])),{"n": runtime.contextOrFrameLookup(context, frame, "num_results"),"q": runtime.contextOrFrameLookup(context, frame, "q"),"product": runtime.contextOrFrameLookup(context, frame, "product_titles")},true)), env.opts.autoescape);
output += "\n    ";
;
}
output += "\n  ";
;
}
else {
output += "\n    ";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("f").call(context, (lineno = 20, colno = 8, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Sorry! 0 results found for ‘<span>%(q)s</span>’ for ‘<span>%(product)s</span>’"])),{"q": runtime.contextOrFrameLookup(context, frame, "q"),"product": runtime.contextOrFrameLookup(context, frame, "product_titles")},true)), env.opts.autoescape);
output += "\n  ";
;
}
output += "\n</h2>\n<nav class=\"tabs\">\n  <ul id=\"doctype-filter\" class=\"tabs--list search-filter cf\">\n    <li class=\"tabs--item\">\n      <a ";
output += runtime.suppressValue(env.getFilter("class_selected").call(context, runtime.contextOrFrameLookup(context, frame, "w"),3), env.opts.autoescape);
output += " href=\"#\" data-instant-search-set-params=\"w=3\" data-instant-search-unset-params=\"page\" data-instant-search=\"link\">\n        <span>";
output += runtime.suppressValue((lineno = 29, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["View All"])), env.opts.autoescape);
output += "</span>\n      </a>\n    </li>\n    <li class=\"tabs--item\">\n      <a ";
output += runtime.suppressValue(env.getFilter("class_selected").call(context, runtime.contextOrFrameLookup(context, frame, "w"),1), env.opts.autoescape);
output += " href=\"#\" data-instant-search-set-params=\"w=1\" data-instant-search-unset-params=\"page\" data-instant-search=\"link\">\n        <span>";
output += runtime.suppressValue((lineno = 34, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Help Articles Only"])), env.opts.autoescape);
output += "</span>\n      </a>\n    </li>\n    <li class=\"tabs--item\">\n      <a ";
output += runtime.suppressValue(env.getFilter("class_selected").call(context, runtime.contextOrFrameLookup(context, frame, "w"),2), env.opts.autoescape);
output += " href=\"#\" data-instant-search-set-params=\"w=2\" data-instant-search-unset-params=\"page\" data-instant-search=\"link\">\n        <span>";
output += runtime.suppressValue((lineno = 39, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Community Discussion Only"])), env.opts.autoescape);
output += "</span>\n      </a>\n    </li>\n  </ul>\n</nav>\n\n";
if(runtime.contextOrFrameLookup(context, frame, "num_results") > 0) {
output += "\n  <section class=\"topic-list content-box\">\n    ";
frame = frame.push();
var t_7 = runtime.contextOrFrameLookup(context, frame, "results");
if(t_7) {t_7 = runtime.fromIterator(t_7);
var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("doc", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n      ";
output += runtime.suppressValue((lineno = 48, colno = 22, runtime.callWrap(t_4, "search_result", context, [t_8,runtime.contextOrFrameLookup(context, frame, "icons")])), env.opts.autoescape);
output += "\n    ";
;
}
}
frame = frame.pop();
output += "\n  </section>\n";
;
}
else {
output += "\n  <p>";
output += runtime.suppressValue((lineno = 52, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Try searching again with a different keyword, or browse our featured articles below instead."])), env.opts.autoescape);
output += "</p>\n\n  <section class=\"sumo-card-grid extra-padding content-box\">\n    <div class=\"scroll-wrap\">\n      ";
frame = frame.push();
var t_11 = runtime.contextOrFrameLookup(context, frame, "fallback_results");
if(t_11) {t_11 = runtime.fromIterator(t_11);
var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("doc", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n        <div class=\"card card--article result document\">\n          <img class=\"card--icon-sm\" src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "icons")),"reader_mode"), env.opts.autoescape);
output += "\" alt=\"\" aria-hidden=\"true\" />\n          <div class=\"card--details\">\n            <h3 class=\"card--title\">\n              <a class=\"expand-this-link title\" href=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"url"), env.opts.autoescape);
output += "\"\n                data-event-name=\"link_click\"\n                data-event-parameters='{\"link_name\": \"search-fallback.kb-article\"}'>\n                ";
output += runtime.suppressValue(runtime.memberLookup((t_12),"document_title"), env.opts.autoescape);
output += "\n              </a>\n            </h3>\n            <p class=\"card--desc\">\n              ";
output += runtime.suppressValue(runtime.memberLookup((t_12),"document_summary"), env.opts.autoescape);
output += "\n            </p>\n          </div>\n        </div>\n      ";
;
}
}
frame = frame.pop();
output += "\n    </div>\n  </section>\n";
;
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "total_is_approximate")) {
output += "\n  ";
var t_13;
t_13 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"has_previous") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"has_next");
frame.set("show_pagination", t_13, true);
if(frame.topLevel) {
context.setVariable("show_pagination", t_13);
}
if(frame.topLevel) {
context.addExport("show_pagination", t_13);
}
output += "\n";
;
}
else {
output += "\n  ";
var t_14;
t_14 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"num_pages") > 1;
frame.set("show_pagination", t_14, true);
if(frame.topLevel) {
context.setVariable("show_pagination", t_14);
}
if(frame.topLevel) {
context.addExport("show_pagination", t_14);
}
output += "\n";
;
}
output += "\n";
if(runtime.contextOrFrameLookup(context, frame, "show_pagination")) {
output += "\n<div class=\"pagination--wrap\">\n  ";
if(!runtime.contextOrFrameLookup(context, frame, "total_is_approximate")) {
output += "\n  <p>\n  ";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("f").call(context, (lineno = 86, colno = 6, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Page %(current)s of %(total)s"])),{"current": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"number"),"total": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"num_pages")},true)), env.opts.autoescape);
output += "\n  </p>\n  ";
;
}
output += "\n  <ol class=\"pagination\">\n  ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"has_previous")) {
output += "\n    <li class=\"prev\">\n      <a class=\"btn-page btn-page-prev\" href=\"#\" data-instant-search=\"link\" data-instant-search-set-params=\"page=";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"number") - 1, env.opts.autoescape);
output += "\">\n        <svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n            <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n                <polyline stroke=\"currentColor\" stroke-width=\"2\" points=\"15 5 8 12 15 19\"></polyline>\n            </g>\n        </svg>\n        <span class=\"sr-only\">";
output += runtime.suppressValue((lineno = 100, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Previous"])), env.opts.autoescape);
output += "</span>\n      </a>\n    </li>\n  ";
;
}
output += "\n  ";
if(!runtime.contextOrFrameLookup(context, frame, "total_is_approximate") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"dotted_lower")) {
output += "\n    <li><a href=\"#\" data-instant-search=\"link\" data-instant-search-set-params=\"page=1\">";
output += runtime.suppressValue(1, env.opts.autoescape);
output += "</a></li>\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"page_range")),0) != 2) {
output += "\n      <li class=\"skip\">&hellip;</li>\n    ";
;
}
output += "\n  ";
;
}
output += "\n  ";
if(!runtime.contextOrFrameLookup(context, frame, "total_is_approximate")) {
output += "\n    ";
frame = frame.push();
var t_17 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"page_range");
if(t_17) {t_17 = runtime.fromIterator(t_17);
var t_16 = t_17.length;
for(var t_15=0; t_15 < t_17.length; t_15++) {
var t_18 = t_17[t_15];
frame.set("x", t_18);
frame.set("loop.index", t_15 + 1);
frame.set("loop.index0", t_15);
frame.set("loop.revindex", t_16 - t_15);
frame.set("loop.revindex0", t_16 - t_15 - 1);
frame.set("loop.first", t_15 === 0);
frame.set("loop.last", t_15 === t_16 - 1);
frame.set("loop.length", t_16);
output += "\n      <li ";
output += runtime.suppressValue(env.getFilter("class_selected").call(context, t_18,runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"number")), env.opts.autoescape);
output += ">\n        <a href=\"#\" class=\"";
if(t_18 == runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"number")) {
output += "btn-page";
;
}
output += "\" data-instant-search=\"link\" data-instant-search-set-params=\"page=";
output += runtime.suppressValue(t_18, env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(t_18, env.opts.autoescape);
output += "</a>\n      </li>\n    ";
;
}
}
frame = frame.pop();
output += "\n  ";
;
}
output += "\n  ";
if(!runtime.contextOrFrameLookup(context, frame, "total_is_approximate") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"dotted_upper")) {
output += "\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"page_range")),-1) != runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"num_pages") - 1) {
output += "\n      <li class=\"skip\">&hellip;</li>\n    ";
;
}
output += "\n    <li><a href=\"#\" data-instant-search=\"link\" data-instant-search-set-params=\"page=";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"num_pages"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"num_pages"), env.opts.autoescape);
output += "</a></li>\n  ";
;
}
output += "\n  ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"has_next")) {
output += "\n    <li class=\"next\">\n      <a href=\"#\" data-instant-search=\"link\" data-instant-search-set-params=\"page=";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pagination")),"number") + 1, env.opts.autoescape);
output += "\">\n        <span class=\"sr-only\">";
output += runtime.suppressValue((lineno = 126, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Next"])), env.opts.autoescape);
output += "</span>\n        <svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n            <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n                <polyline stroke=\"currentColor\" stroke-width=\"2\" points=\"9 19 16 12 9 5\"></polyline>\n            </g>\n        </svg>\n      </a>\n    </li>\n  ";
;
}
output += "\n  </ol>\n</div>\n";
;
}
output += "\n\n\n";
if(runtime.contextOrFrameLookup(context, frame, "num_results") == 0 && runtime.contextOrFrameLookup(context, frame, "support_aaq_url") && (runtime.contextOrFrameLookup(context, frame, "product") != "firefox-enterprise")) {
output += "\n<div class=\"sumo-page-section--inner\">\n  <div class=\"card card--ribbon is-inverse\">\n    <div class=\"card--details\">\n      <h3 class=\"card--title\">\n        <svg class=\"card--icon-sm\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n          <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n            <g transform=\"translate(2.000000, 1.878680)\" stroke=\"#fff\" stroke-width=\"2\">\n              <path d=\"M9,1.12132031 L2,1.12132031 C0.8954305,1.12132031 5.32907052e-15,2.01675081 5.32907052e-15,3.12132031 L5.32907052e-15,15.1213203 C5.32907052e-15,16.2258898 0.8954305,17.1213203 2,17.1213203 L11,17.1213203 L13,21.1213203 L15,17.1213203 L17,17.1213203 C18.1045695,17.1213203 19,16.2258898 19,15.1213203 L19,9.12132031\"></path>\n              <path d=\"M15.5,0.621320312 C16.3284271,-0.207106783 17.6715729,-0.207106769 18.5,0.621320344 C19.3284271,1.44974746 19.3284271,2.79289318 18.5,3.62132031 L11,11.1213203 L7,12.1213203 L8,8.12132031 L15.5,0.621320312 Z\"></path>\n            </g>\n          </g>\n        </svg>\n        ";
output += runtime.suppressValue((lineno = 153, colno = 12, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Still need help?"])), env.opts.autoescape);
output += "\n      </h3>\n\n      <p class=\"card--desc\">\n        ";
if(runtime.contextOrFrameLookup(context, frame, "is_ticketed")) {
output += "\n          ";
output += runtime.suppressValue((lineno = 158, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["We’re here for you! If you haven’t found a solution after exploring our help articles, you can get in touch with our support team."])), env.opts.autoescape);
output += "\n        ";
;
}
else {
output += "\n          ";
output += runtime.suppressValue((lineno = 160, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["We’re here for you. Post a question to our support forums and get answers from our community of experts."])), env.opts.autoescape);
output += "\n        ";
;
}
output += "\n      </p>\n      <a\n        id=\"search-results-aaq-link\"\n        class=\"sumo-button primary-button button-lg\"\n        href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "support_aaq_url"), env.opts.autoescape);
output += "\"\n        data-event-name=\"link_click\"\n        data-event-parameters=’{\"link_name\": \"search-results.aaq-step-3.get-support\"}’>\n        ";
if(runtime.contextOrFrameLookup(context, frame, "is_ticketed")) {
output += "\n          ";
output += runtime.suppressValue((lineno = 170, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Contact Support"])), env.opts.autoescape);
output += "\n        ";
;
}
else {
output += "\n          ";
output += runtime.suppressValue((lineno = 172, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Ask the Community"])), env.opts.autoescape);
output += "\n        ";
;
}
output += "\n      </a>\n    </div>\n  </div>\n</div>\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
